import React from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {
  // WhatsApp group links
  const whatsappGroups = [
    { 
      name: "Fresher Job Adda Group 1", 
      link: "https://chat.whatsapp.com/FUlOD1Yl39A8C8BbYqetQt", 
      description: "IT & Software Jobs" 
    },
    { 
      name: "Fresher Job Adda Group 2", 
      link: "https://chat.whatsapp.com/IfT5nx0YlscAhC5cgpZqmV", 
      description: "MBA & Non-Tech Jobs" 
    },
    { 
      name: "Fresher Job Adda Group 3", 
      link: "https://chat.whatsapp.com/IXmwZhogcEm0CZo3plnMqk", 
      description: "All Job Updates" 
    }
  ];

  return (
    <section className="py-5"  style={{ background: 'linear-gradient(135deg, #5e35b1 0%, #7b1fa2 100%)' }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 mb-4 mb-lg-0">
            <h1 className="display-5 fw-bold text-white">Find Your Dream Job</h1>
            <p className="lead text-white mb-4">
              Discover thousands of job opportunities with top employers. Your next career move starts here.
            </p>
            <div className="d-flex flex-wrap gap-2">
              <Link to="/browse-jobs" className="btn btn-light btn-lg px-4">
                <i className="fas fa-search me-2"></i> Browse All Jobs
              </Link>
              <Link to="/companies" className="btn btn-outline-light btn-lg px-4">
                <i className="fas fa-building me-2"></i> Top Companies
              </Link>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="card border-0 shadow">
              <div className="card-header bg-success text-white py-3">
                <h5 className="mb-0">
                  <i className="fab fa-whatsapp me-2"></i> Join Fresher Job Adda Groups
                </h5>
              </div>
              <div className="card-body">
                <p className="card-text text-muted mb-3">
                  Get instant job notifications directly on WhatsApp. Join our groups to never miss an opportunity.
                </p>
                <div className="d-grid gap-2">
                  {whatsappGroups.map((group, index) => (
                    <a 
                      key={index}
                      href={group.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="btn btn-outline-success d-flex align-items-center justify-content-between"
                      style={{
                        transition: 'all 0.3s ease',
                        borderRadius: '8px',
                        padding: '12px 15px'
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <i className="fab fa-whatsapp fs-4 me-3" style={{ color: '#25D366' }}></i>
                        <div className="text-start">
                          <span className="d-block fw-bold">{group.name}</span>
                          <small className="text-muted">{group.description}</small>
                        </div>
                      </div>
                      <i className="fas fa-chevron-right"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner; 